import { createContext } from 'react';

export const CheckoutStateContext = createContext({});
